import React from "react";
import ATable from "../../common/table";
import { permissioned } from "../../common/permissionedHoc";

const DiscoverTransactionsTable = props => {
  //Column Definition
  const columns = [
    {
      header: "S/N",
      width: 50,
      render: row => <div>{props.paginatedCallback(row.viewIndex)}</div>
    },
    {
      header: "Issuer Code",
      accessor: "issuerCode"
    },
    {
      header: "NRID",
      accessor: "nrid"
    },
    {
      header: "Merchant",
      accessor: "merchant"
    },
    {
      header: "PAN",
      accessor: "pan",
      width: 130
    },
    {
      header: "Terminal ID",
      accessor: "terminalId"
    },
    {
      header: "STAN",
      accessor: "stan",
      width: 100
    },
    {
      header: "Tran. Date",
      accessor: "transactionDate"
    },
    {
      header: "Tran. Type",
      accessor: "transactionType"
    },
    {
      header: "Tran. Amount",
      accessor: "transactionAmount"
    },
    {
      header: "Settlement Amount",
      accessor: "settlementAmount"
    },
    {
      header: "Scheme Amount",
      accessor: "schemeAmount"
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.tableData}
      columns={columns}
      loading={props.loading}
      onRowClick={props.onRowClick}
      onChange={props.onTableChange}
    />
  );
};

export default permissioned(DiscoverTransactionsTable);



// WEBPACK FOOTER //
// ./src/components/discover/newCase/TransactionsTable.js